<script lang="ts">
	import GeneralSettingsV2 from './GeneralSettingsV2.svelte';
</script>

<GeneralSettingsV2 />
